import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {CastRoleInfo} from 'src/app/model/cast-role-info.model';
import {ContentCast, PageOfContentCast} from 'src/app/model/content-cast.model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CastControllerService {
  readonly castApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.CAST;
  constructor(private http: HttpClient) {}

  getAllCasts(
    name?: string,
    castId?: number,
    page?: number,
    itemCount?: number,
    pageable?: boolean,
    sortParams?: string[],
  ): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (name) {
      queryParams = queryParams.set('name', <any>name);
    }
    if (castId) {
      queryParams = queryParams.set('id', <any>castId);
    }
    if (page != undefined) {
      queryParams = queryParams.set('page', <any>page);
    }

    if (itemCount) {
      queryParams = queryParams.set('itemCount', <any>itemCount);
    }

    if (sortParams) {
      queryParams = queryParams.set('sortParam', <any>sortParams);
    }

    if (pageable != undefined) {
      queryParams = queryParams.set('pageable', <any>pageable);
      return this.http.get<ContentCast[]>(this.castApiUrl, {params: queryParams});
    } else {
      return this.http.get<PageOfContentCast>(this.castApiUrl, {params: queryParams});
    }
  }

  addCast(castObj: ContentCast): Observable<any> {
    return this.http.post<any>(this.castApiUrl, castObj);
  }

  editCast(castObj: ContentCast): Observable<any> {
    return this.http.put<any>(this.castApiUrl, castObj);
  }

  deleteCast(id: number): Observable<any> {
    return this.http.delete<any>(this.castApiUrl + `/${id}`, {responseType: 'text' as 'json'});
  }

  setPosterToCast(castId: number, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    //formData.append('updateChilds', updateChilds.toString());
    return this.http.post<any>(this.castApiUrl + `/${castId}/posters/upload`, formData, {responseType: 'text' as 'json'});
  }
  setDefaultCatPoster(castId: number, posterId: number): Observable<any> {
    return this.http.put<any>(this.castApiUrl + `/${castId}/posters/${posterId}/setdefault`, null, {responseType: 'text' as 'json'});
  }

  deletePoster(castId: number, posterId: number): Observable<any> {
    return this.http.delete<any>(this.castApiUrl + `/${castId}/posters/${posterId}`, {responseType: 'text' as 'json'});
  }
  getCastPosters(castId: number, posterId: number): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (posterId) {
      queryParams = queryParams.set('posterIds', <any>posterId);
    }
    return this.http.get<any>(this.castApiUrl + `/${castId}/posters`, {params: queryParams, responseType: 'text' as 'json'});
  }


  getCastRoleInformation(id: number): Observable<CastRoleInfo[]> {
    return this.http.get<CastRoleInfo[]>(this.castApiUrl + `/${id}/getcastroleinformation`);
  }
}
